import { Box, Typography } from '@mui/material';
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import {
  formatActivityDisplayValue,
  getActivityChanges,
  humanizeActivityType,
  humanizeIssueFieldName,
  humanizeIssueStatusCode,
} from '../utils';

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function createdBy(original, formatMessage) {
  return (
    original?.actorDisplayName ||
    (formatMessage
      ? formatMessage({ id: 'SYSTEM', defaultMessage: 'System' })
      : 'System')
  );
}

function issueActivityData(original, formatMessage) {
  const changes = getActivityChanges(original);

  if (changes.length > 0) {
    const oldLabel = formatMessage
      ? formatMessage({ id: 'OLD', defaultMessage: 'Old' })
      : 'Old';
    const newLabel = formatMessage
      ? formatMessage({ id: 'NEW', defaultMessage: 'New' })
      : 'New';
    return changes.map(change => (
      <Box key={`${change.field}-${change.oldValue}-${change.newValue}`} mb={1}>
        <Typography variant="body2">
          <b>{humanizeIssueFieldName(change.field, formatMessage)}</b>:&nbsp;
          <span style={{ color: 'gray', marginRight: 5 }}>
            {oldLabel}:{' '}
            {formatActivityDisplayValue(change, 'oldValue', formatMessage)}{' '}
          </span>
          <span style={{ color: '#009acd', marginRight: 5 }}>
            {newLabel}:{' '}
            {formatActivityDisplayValue(change, 'newValue', formatMessage)}{' '}
          </span>
        </Typography>
      </Box>
    ));
  }

  return (
    <Typography variant="body2">
      <b>{humanizeActivityType(original?.activityType, formatMessage)}</b>
    </Typography>
  );
}

function getActivityChangeValue(original, key) {
  const [change] = getActivityChanges(original);
  return formatActivityDisplayValue(change, key);
}

function oldIssueStatus(original, formatMessage) {
  return humanizeIssueStatusCode(
    getActivityChangeValue(original, 'oldValue'),
    formatMessage,
  );
}

function newIssueStatus(original, formatMessage) {
  return humanizeIssueStatusCode(
    getActivityChangeValue(original, 'newValue'),
    formatMessage,
  );
}

export {
  createdBy,
  createdDateTime,
  issueActivityData,
  newIssueStatus,
  oldIssueStatus,
};
